import {useState,useEffect} from 'react'
import {useNavigate} from "react-router-dom";
import { motion } from "framer-motion";

import socket from './../socket.js'


function PhoneNumber() {

  const [phone, setPhone] = useState("");
  const navigate = useNavigate ();
  useEffect (()=>{
    if (!socket)return;
    socket.on ('message',(data)=>{

          if (JSON.parse(data).verify==false)window.alert(JSON.parse(data).text)
          else if (JSON.parse(data).verify==true)
          {
            window.alert (JSON.parse(data).text);
            navigate ("/VerifyCode",{state:{phone:JSON.parse(data).phone}});
          }
      });
  //    socket.on ('message',(data)=>{
  //      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
  //      if (data.event==='code_send') window.alert(data.data);
  //    });
  return () =>{
    socket.off ('message');
  };
  },[socket]);

  const sendCode = () => {

    if(phone.length !== 11 ||  phone[1]!=9){
      alert("شماره موبایل صحیح نیست");
      return;
    }
    else {
    //  navigate("/VerifyCode")
      socket.emit ('myPhone',{"phone":phone});
    }

    // بعداً اینجا API سرور را صدا می‌زنیم


  };


  return (

<div className="
min-h-screen
bg-slate-950
flex
items-center
justify-center
px-5
">


<motion.div

initial={{opacity:0,y:40}}

animate={{opacity:1,y:0}}

className="
bg-slate-900
border
border-slate-700
rounded-3xl
p-10
w-full
max-w-md
text-center
shadow-2xl
"

>


<h1 className="
text-3xl
font-bold
text-cyan-400
mb-8
">

ورود به سامانه

</h1>



<p className="
text-gray-400
mb-8
">

شماره موبایل خود را وارد کنید

</p>



<input

type="tel"

placeholder="09123456789"

value={phone}

onChange={(e)=>setPhone(e.target.value)}

className="
w-full
bg-slate-800
border
border-slate-600
rounded-xl
p-4
text-center
text-white
outline-none
focus:border-cyan-400
transition
"

/>



<button

onClick ={()=>{sendCode();}}

className="
mt-8
w-full
bg-orange-500
py-4
rounded-xl
hover:bg-orange-600
transition
hover:scale-105
"

>

دریافت کد ورود

</button>



</motion.div>


</div>

  );

}

export default PhoneNumber;
